import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FlexCol, FlexRow } from "../components/generic/Containers";
import { LandingPagedHeader } from "../components/landingPage/LandingPageHeader";
import { Footer } from "../components/Footer";
import { BCHeader1, Body1 } from "../components/generic/BCHeaders";
import {BCPrimaryButton, BCTertiaryButton} from "../components/generic/BCButtons";
import { BCIcon, ICONS } from "../components/generic/BCIcons";
import { ARTICLES_MARKUP } from "../constants/ArticlesConfig";
import ReactMarkdown from "react-markdown";
import {STRINGS} from "../constants/Strings";
import {useGlobalState} from "../GlobalState";
import "../css/Markdown.css";

export const BlogPublicDetailPage: React.FC = () => {
    const { isAuthenticated, setShowAuthModal, setAuthModalMode } = useGlobalState();
    const { blogId } = useParams();
    const navigate = useNavigate();

    // Find the blog by navUrl
    const blog = ARTICLES_MARKUP.find(article => article.navUrl === blogId);

    if (!blog) {
        return (
            <FlexCol widthPercent={100}>
                <LandingPagedHeader isEducator={false} />
                <FlexCol padding={2} gap={2} maxWidth={80} alignSelf="center" widthPercent={100}>
                    <BCHeader1 text="Blog Not Found" />
                    <Body1 text="The blog post you're looking for doesn't exist." />
                    <BCTertiaryButton 
                        text="Back to Blog Posts"
                        onClick={() => navigate('/blog-public')}
                        iconLeft={ICONS.LEFT_ARROW}
                    />
                </FlexCol>
                <Footer />
            </FlexCol>
        );
    }

    return (
        <FlexCol widthPercent={100}>
            <LandingPagedHeader isEducator={false} />
            <FlexCol padding={2} gap={2} maxWidth={50} alignSelf="center" widthPercent={100}>
                <FlexCol gap={1} maxWidth={50} alignSelf="center">
                    <FlexRow>
                        <BCTertiaryButton
                            text="Back to Blog Posts"
                            onClick={() => navigate('/blog-public')}
                            iconLeft={ICONS.LEFT_ARROW}
                        />
                    </FlexRow>
                    <img src={blog.thumbnail} alt={`${blog.name} icon`} style={{ maxWidth: '100%', height: 'auto' }} />
                    <div className="react-markdown">
                        <ReactMarkdown>{blog.content}</ReactMarkdown>
                    </div>
                </FlexCol>
                {!isAuthenticated &&
                    <BCPrimaryButton
                        className={'dashboard-primary-cta'}
                        text={STRINGS.LANDING_PAGE_HERO_COMPONENT_CTA} iconRight={ICONS.RIGHT_ARROW} onClick={() => {
                        setAuthModalMode('register');
                        setShowAuthModal(true);
                    }}/>
                }
            </FlexCol>
            <Footer />
        </FlexCol>
    );
};
